/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initMobileGridArrows(holder) {
    if (!holder) return;
    if (holder.dataset.mobileArrowsReady === 'true' && holder.querySelector('.mobile-slider__arrows')) return;

    var slider = holder.querySelector('[data-grid-slider]');
    var firstItem = slider && slider.querySelector('[data-grid-item]');

    if (!slider || !firstItem || !window.theme || !window.theme.sliderArrows) return;

    holder.dataset.mobileArrowsReady = 'true';

    var buttonsWrap = document.createElement('div');
    buttonsWrap.className = 'slider__arrows mobile-slider__arrows';
    buttonsWrap.innerHTML = window.theme.sliderArrows.prev + window.theme.sliderArrows.next;
    holder.appendChild(buttonsWrap);

    var prev = buttonsWrap.querySelector('[data-button-prev]');
    var next = buttonsWrap.querySelector('[data-button-next]');

    function positionArrows() {
      var image = firstItem.querySelector('[data-product-image]');
      if (!image) return;

      buttonsWrap.style.setProperty('--button-position', image.offsetTop + image.offsetHeight / 2 + 'px');
    }

    function getVisibleItem() {
      var items = Array.prototype.slice.call(slider.querySelectorAll('[data-grid-item]'));
      var scrollLeft = slider.scrollLeft;

      return items.reduce(function(closest, item) {
        if (!closest) return item;

        return Math.abs(item.offsetLeft - scrollLeft) < Math.abs(closest.offsetLeft - scrollLeft) ? item : closest;
      }, null);
    }

    function updateButtons() {
      var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

      if (prev) prev.disabled = slider.scrollLeft <= 2;
      if (next) next.disabled = slider.scrollLeft >= maxScroll;
    }

    function goTo(direction) {
      var current = getVisibleItem();
      var target = direction === 'next' ? current && current.nextElementSibling : current && current.previousElementSibling;

      if (!target) return;

      slider.scrollTo({
        top: 0,
        left: target.offsetLeft,
        behavior: 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function(event) {
        event.preventDefault();
        goTo('prev');
      });
    }

    if (next) {
      next.addEventListener('click', function(event) {
        event.preventDefault();
        goTo('next');
      });
    }

    slider.addEventListener('scroll', window.theme.debounce(updateButtons, 80), { passive: true });
    window.addEventListener('resize', window.theme.debounce(function() {
      positionArrows();
      updateButtons();
    }, 120));

    positionArrows();
    updateButtons();
  }

  function initMobileFeaturedCollectionArrows() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll('grid-slider[data-mobile-slider-arrows]').forEach(initMobileGridArrows);
  }

  document.addEventListener('DOMContentLoaded', initMobileFeaturedCollectionArrows);
  document.addEventListener('shopify:section:load', initMobileFeaturedCollectionArrows);


  



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
